import React, { useState } from "react";
import Create from "../create/Create";
import MainStore from "../stores/MainStore";

const useCreateModal = ({ onObjectCreated, type, payload, action, onBack }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { player } = MainStore();

  function openModal() {
    setModalOpen(true);
  }
  function closeModal() {
    setModalOpen(false);
  }
  return {
    open: openModal,
    close: closeModal,

    divs: (
      <div style={{ position: "relative" }}>
        {modalOpen && (
          <div
            className="divRow"
            style={{
              border: "5px solid grey",
              width: "1200px",
              height: "500px",
              overflow: "auto",
              position: "fixed",
              top: "20%",
              left: "20%",
              zIndex: 1111,
            }}
          >
            <Create
              onBack={onBack}
              player={player}
              onObjectCreated={onObjectCreated}
              action={action}
              create={{ type, payload }}
              setCreate={closeModal}
              width="100%"
              height="100%"
              player={player}
            />
          </div>
        )}
      </div>
    ),
  };
};

export default useCreateModal;
